import { sunExposure } from './sunExposure';
import { termsReminder } from './termsReminder';

export const pt = {
  sunExposure,
  termsReminder,
};
